import { useState } from "react";

import { Radio, RadioGroup } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { LeadComponent, MainComponent } from "@/types/programs";

interface ReleaseComponentOptionProps {
  onChange: (arg0: boolean) => void;
  defaultValue?: boolean;
  component: MainComponent | LeadComponent;
  warningTitle: string;
}

export function ReleaseComponentOption({
  onChange,
  defaultValue,
  component,
  warningTitle,
}: ReleaseComponentOptionProps) {
  const [isReleaseDependentComponents, setIsReleaseDependentComponents] =
    useState(defaultValue ?? true);

  return (
    <Box mt={2}>
      <Box>
        {warningTitle}:{" "}
        <b>
          {component.dependentComponents
            ?.map((dependentComponent) => dependentComponent?.name)
            .join(", ")}
        </b>
        . Please choose one of the following options:
      </Box>
      <Box style={{ marginTop: 8 }}>
        <RadioGroup
          selectedValue={isReleaseDependentComponents ? "true" : "false"}
          onChange={(e) => {
            setIsReleaseDependentComponents(e.currentTarget.value === "true");
            onChange(e.currentTarget.value === "true");
          }}
        >
          <Radio
            label="Remove completion requirement - All participants can access the components above"
            value={"true"}
          />
          <Radio
            label={`Keep completion requirement - Participants who haven't finished this will be blocked from proceeding`}
            value={"false"}
          />
        </RadioGroup>
      </Box>
    </Box>
  );
}
